import { api } from '@/core/http/apiClient';
import type {
  AdditionalNotesScreen,
  NoteDialogData,
  NoteRow,
  SaveNotePayload,
  SetNoteEnabledPayload,
  SingletonNoteType,
} from '@/core/models/notes.models';

export const notesService = {
  /** The period's notes; without a period id the API uses the client's latest accounting period. */
  getNotes: (clientId: string, accountingPeriodId?: string | null) => {
    const options = accountingPeriodId ? { params: { accountingPeriodId } } : {};
    return api.get<AdditionalNotesScreen>(`AdditionalNotes/getNotes/${clientId}`, options);
  },

  saveNote: (payload: SaveNotePayload) => api.post<NoteRow>('AdditionalNotes/saveNote', payload),

  setNoteEnabled: (payload: SetNoteEnabledPayload) => api.post<NoteRow>('AdditionalNotes/setNoteEnabled', payload),

  deleteNote: (id: string) => api.post<boolean>(`AdditionalNotes/deleteNote/${id}`, {}),

  /** Saves the dialog's note (a new list note when the dialog was opened without one). */
  saveFromDialog: (data: NoteDialogData, content: unknown) =>
    notesService.saveNote({
      clientId: data.clientId,
      accountingPeriodId: data.accountingPeriodId,
      id: data.note?.id ?? null,
      noteType: data.noteType,
      isEnabled: data.note?.isEnabled ?? true,
      content,
    }),

  /** Includes a check-box note from its dialog. */
  enableFromDialog: (data: NoteDialogData) =>
    notesService.setNoteEnabled({
      clientId: data.clientId,
      accountingPeriodId: data.accountingPeriodId,
      noteType: data.noteType as SingletonNoteType,
      isEnabled: true,
    }),
};
